<app-dialog-header
  [header]="'user.mail_form.header' | translate"
  iconClass="icon-send-msg-icon"
>
</app-dialog-header>
<app-dialog-content [formGroup]="form">
  <div class="p-grid">
    <div class="p-col-8 p-offset-2 p-col-align-center">
      <app-wysiwyg
        [appApiErrors]="errors.message"
        [appSuggestions]="['ACTIVE_DIRECTORY', 'USER', 'SERVER']"
        [formControl]="form.controls?.message"
        [placeholder]="'user.mail_form.form.message.placeholder' | translate"
      ></app-wysiwyg>
    </div>
    <div class="p-col-8 p-offset-2">
      <app-form-control-error [control]="form.get('message')"></app-form-control-error>
    </div>
  </div>
</app-dialog-content>
<div class="dialog-footer">
  <button
    (click)="close()"
    data-qa="user-list-mail-dialog-close-button"
    type="button"
    class="proget-button text-only"
  >
    {{ 'button.close.label' | translate }}
  </button>
  <button
    [submitButton]="form"
    (click)="submit(form)"
    data-qa="user-list-mail-dialog-send-button"
    type="button"
    class="proget-button text-only primary-button"
  >
    {{ 'button.send.label' | translate }}
  </button>
</div>
